export default [
  {
    field: 'ssn',
    method: 'isEmpty',
    validWhen: false,
    message: 'Last 4 digits of your SSN are required',
  },
  {
    field: 'ssn',
    method: 'isLength',
    validWhen: true,
    message: 'Last 4 digits of your SSN are required',
    options: [{ min: 4, max: 4 }],
  },
  {
    field: 'ssn',
    method: 'isInt',
    validWhen: true,
    message: 'Last 4 digits of your SSN should be numeric',
  },
];
